import {
  Box,
  FormErrorIcon,
  FormErrorMessage,
  FormHelperText,
  StyleProps,
  Text,
  useFormControlContext,
} from "@chakra-ui/react";
import { dataAttr } from "@chakra-ui/utils";
import React from "react";

export type InputType = "text" | "textarea" | "date" | undefined;

export interface InputContentProps {
  inputType?: InputType;
}

export const InputWrapper: React.FC<React.PropsWithChildren<StyleProps>> = ({
  children,
  ...props
}) => {
  const { isInvalid } = useFormControlContext();
  return (
    <Box
      className="mb-input-wrapper"
      data-invalid={dataAttr(isInvalid)}
      position="relative"
      borderRadius="4px"
      bg="white"
      borderWidth="1px"
      borderColor="gray.300"
      overflow="hidden"
      sx={{
        "&:focus-within, [data-editing] &": {
          borderColor: "primary.500",
          "& .chakra-input__left-addon, & .chakra-input__right-addon": {
            borderColor: "primary.500",
          },
        },
        _invalid: {
          "&&": {
            borderColor: "error.600",
            "& .chakra-input__left-addon, & .chakra-input__right-addon": {
              borderColor: "error.600",
            },
          },
        },
        "[aria-readonly] &": {
          borderColor: "gray.50",
        },
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export const InputContent: React.FC<
  React.PropsWithChildren<InputContentProps>
> = ({ children, inputType }) => {
  const { isInvalid } = useFormControlContext();
  return (
    <Box
      className="mb-input-content"
      data-invalid={dataAttr(isInvalid)}
      data-input-type={inputType}
      position="relative"
      flex={1}
    >
      {children}
    </Box>
  );
};

export const InputMessages: React.FC<{
  helpText?: string;
  error?: string;
}> = ({ helpText, error }) => {
  if (error) {
    return (
      <FormErrorMessage data-has-help-text={dataAttr(!!helpText)}>
        <FormErrorIcon />
        <Text>{error}</Text>
      </FormErrorMessage>
    );
  }
  if (helpText) {
    return <FormHelperText>{helpText}</FormHelperText>;
  }
  return null;
};
